import {
  CalendarDaysIcon,
  MessagesSquareIcon,
  BookOpenIcon,
  MessageCircleIcon,
  PuzzleIcon,
  BarChart3Icon,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'

export type Module = {
  number: string
  title: string
  icon: LucideIcon
  accent: string
  hook: string
  body: string
  tags: string
}

export const MODULES: Module[] = [
  {
    number: '01',
    title: 'SPANISH LESSON PLANNER™',
    icon: CalendarDaysIcon,
    accent: 'bg-sage',
    hook: 'Plan structured Spanish lessons faster without rebuilding your teaching sequence every time.',
    body: 'Use adaptable lesson frameworks for different levels, objectives, class lengths, individual students, groups and online lessons.',
    tags: 'Lesson Plans · Warm-Ups · Class Structures · Practice · Review · Homework',
  },
  {
    number: '02',
    title: 'GRAMMAR & LANGUAGE TOOLKIT™',
    icon: MessagesSquareIcon,
    accent: 'bg-violet',
    hook: 'Turn Spanish grammar into clear, practical teaching material your students can actually use.',
    body: 'Access structured explanations, examples, exercises, error-correction tasks and communicative practice across different proficiency levels.',
    tags: 'Grammar · Examples · Practice · Corrections · Structures · Application',
  },
  {
    number: '03',
    title: 'VOCABULARY & REAL-LIFE SPANISH™',
    icon: BookOpenIcon,
    accent: 'bg-mustard',
    hook: 'Teach vocabulary through real situations instead of isolated word lists.',
    body: 'Use contextual vocabulary, useful expressions, language chunks, mini-dialogues and practical communication tasks across everyday topics.',
    tags: 'Vocabulary · Expressions · Real-Life Spanish · Dialogues · Context · Practice',
  },
  {
    number: '04',
    title: 'SPEAKING & CONVERSATION LIBRARY™',
    icon: MessageCircleIcon,
    accent: 'bg-steel',
    hook: 'Stop wondering what to ask next when your students need more speaking practice.',
    body: 'Access structured conversation prompts, role-plays, debates, storytelling activities, problem-solving tasks and speaking challenges from beginner to advanced levels.',
    tags: 'Conversation · Role-Plays · Fluency · Debates · Scenarios · Speaking',
  },
  {
    number: '05',
    title: 'READY-TO-USE SPANISH ACTIVITIES™',
    icon: PuzzleIcon,
    accent: 'bg-coral',
    hook: 'Access practical teaching activities whenever you need to build an engaging lesson quickly.',
    body: 'Use adaptable resources for grammar, vocabulary, speaking, reading, writing, pronunciation, review and lesson reinforcement.',
    tags: 'Activities · Practice · Reading · Writing · Review · Adaptations',
  },
  {
    number: '06',
    title: 'LEVEL PROGRESSION & ASSESSMENT SYSTEM™',
    icon: BarChart3Icon,
    accent: 'bg-brand',
    hook: 'Understand where your students are, identify what needs improvement and decide what should come next.',
    body: 'Use diagnostic tools, skill checks, progress trackers, assessment frameworks, rubrics and structured feedback resources.',
    tags: 'Assessment · Progress · Feedback · Rubrics · Tracking · Next Steps',
  },
]
